import React, { useState, useContext, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";

import Swal from "sweetalert2";

import LogoMain from "../../assets/images/altruist_logo.png";
import { AppContext } from "../../context/AppContext";
import { LoginUser } from "../../api/Api";
import {
  getFromLocalStorage,
  setToLocalStorage,
} from "../../utils/common-utils";

export default function Login() {
  const navigate = useNavigate();
  const { setContextStates } = useContext(AppContext);
  const [inputData, setInputData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  useEffect(() => {
    const savedCredentials = getFromLocalStorage("rememberedCredentials");
    if (savedCredentials) {
      const { email, password } = savedCredentials;
      setInputData({ email, password });
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password } = inputData;
    if (!email || !password) {
      setError(true);
    } else {
      setLoader(true);
      let payload = {
        username: email,
        password: password,
      };
      const response = await LoginUser(payload);
      console.log("responseLogin", response);
      setLoader(false);
      if (response?.data?.statusDescription?.status == 200) {
        if (rememberMe) {
          setToLocalStorage("rememberedCredentials", { email, password });
        } else {
          localStorage.removeItem("rememberedCredentials");
        }
        localStorage.setItem(
          "token",
          response?.data?.loginDetail?.userTokenDetailsList?.jwtToken
        );
        setToLocalStorage("userData", response?.data?.loginDetail);
        setToLocalStorage(
          "sideMenus",
          response?.data?.loginDetail?.userGroup?.[0]?.mainMenu
        );
        setContextStates((prev) => {
          return {
            ...prev,
            actualToken:
              response?.data?.loginDetail?.userTokenDetailsList?.jwtToken,
            profileTab: 1,
          };
        });
        navigate("/dashboard");
        Swal.fire({
          text: response?.data?.statusDescription?.description,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          text: response?.data?.statusDescription?.description,
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    }
  };

  return (
    <div className="bg_image align-items-left min-vh-100">
      <div className="container my-auto">
        <div className="login-box">
          <div className="login-logo">
            <img src={LogoMain} alt="logo" width="210px" />
          </div>
          <div className="login-box-body">
            <p className="login-box-msg mb-3">
              Sign in to start Altruist CMS
            </p>
            <form onSubmit={handleSubmit} noValidate>
              <div className="form-group has-feedback">
                <input
                  type="email"
                  className={`form-control ${
                    error && !inputData.email ? "is-invalid" : ""
                  }`}
                  placeholder="Email Id/Username"
                  value={inputData.email}
                  onChange={(e) =>
                    setInputData({ ...inputData, email: e.target.value })
                  }
                  maxLength="50"
                  required
                />
                {error && !inputData.email && (
                  <div className="invalid-feedback d-block error">
                    Please enter an email id
                  </div>
                )}
              </div>

              <div className="form-group has-feedback">
                <div class="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className={`form-control ${
                      error && !inputData.password ? "is-invalid" : ""
                    }`}
                    placeholder="Password"
                    value={inputData.password}
                    onChange={(e) =>
                      setInputData({
                        ...inputData,
                        password: e.target.value,
                      })
                    }
                    autoComplete="new-password"
                    required
                  />
                  <span
                    class="input-group-text"
                    id="basic-addon2"
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i
                      className={`fa fa-${!showPassword ? "eye-slash" : "eye"}`}
                    ></i>
                  </span>
                </div>

                {error && !inputData.password && (
                  <div className="invalid-feedback d-block error">
                    Please enter a password
                  </div>
                )}
              </div>

              <div className="row">
                <div className="col-md-7">
                  <div className="checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="remember-me"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                      />{" "}
                      Remember Me
                    </label>
                  </div>
                </div>
                <div className="col-md-5">
                  <button
                    type="submit"
                    className="btn btn-primary btn-raised btn-block btn-flat"
                    disabled={loader}
                  >
                    Sign In
                    {loader && <i className="fa fa-spinner fa-spin mx-1"></i>}
                  </button>
                </div>
              </div>
            </form>
            <Link
              to="/forget-password"
              className="link"
              style={{ cursor: "pointer" }}
            >
              I forgot my password
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
